export default "__VITE_ASSET__ca3e1f02__"